var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ec-dialog",
    {
      attrs: { dialog: _vm.visible },
      on: {
        "update:dialog": function($event) {
          _vm.visible = $event
        }
      },
      scopedSlots: _vm._u([
        {
          key: "title",
          fn: function() {
            return [_vm._v(_vm._s(_vm.$t("TransmitTransactionsByTerminal")))]
          },
          proxy: true
        }
      ])
    },
    [
      [
        _c(
          "v-form",
          {
            ref: "form",
            staticClass: "mt-4",
            attrs: { "lazy-validation": "" }
          },
          [
            _c("v-select", {
              attrs: {
                items: _vm.terminals,
                "item-text": "label",
                "item-value": "terminalID",
                label: _vm.$t("Terminal"),
                outlined: "",
                rules: [_vm.vr.primitives.required]
              },
              model: {
                value: _vm.selectedTerminal,
                callback: function($$v) {
                  _vm.selectedTerminal = $$v
                },
                expression: "selectedTerminal"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "d-flex justify-end" },
          [
            _c(
              "v-btn",
              {
                attrs: { color: "success", loading: _vm.loading },
                on: {
                  click: function($event) {
                    return _vm.transmitTransactionsByTerminal()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("OK")))]
            )
          ],
          1
        )
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }